---
**Note:** some sales may be attributed to the campaign even if the person did not open the notification, if the sale happened within a very short time window after receiving the notification.

In these cases, we treat it as if the notification had been opened, adding `+1` to `qtd_cliques`.
